import React from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import ReadMore from "../Event/ReadMore";
import './Blog.css'
function Blog() {
  return (
    <div>
      <NavBar />
      <div className="blog" style={{marginTop: "6rem"}}>
        <div className="blog-entry">
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Tejaswi Shah ||{" "}
                <a href="mailto:tejaswishah1998@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>{" "}
              </h1>
            </div>
            <div className="content-tag">Capegemini</div>
            <span className="content-text">
              <ReadMore>
                Hey guys this is Tejaswi Shah. It’s a great platform that CHESS
                is providing to guide the upcoming batches of Chemical
                Engineering. First of all let me tell you that Capgemini is an
                IT company and I got selected in this company through campus
                placement. Two rounds were conducted: Online Aptitude Test and
                Personal Interview. As I was preparing for CAT exams, so didn't
                need any extra preparation. However, I highly recommend that you
                all practice aptitude from online websites like IndiaBix. There
                was around 80 questions plus a separate section to solve pseudo
                codes. Overall level of difficulty is 4/5. There was no GD round
                but still I prepared for it by keeping myself in touch with
                current affairs and practice speaking in front of mirror. In
                Personal Interview they asked questions mainly from DBMS and
                OOPS. So, I recommend to study these two topics thoroughly. You
                can take help from YouTube Channels. HR round was mere a
                formality. They just asked about my club activities. I was the
                President of Enteract-the Official Dramatics club of NIT
                Durgapur. PI level of difficulty was 3/5. You need to be
                thorough with everything you have written in your CV. Don’t
                write false content in your CV. That’s all about it. Feel free
                to get in touch with me through my mail. Good luck for your
                future endeavors.
              </ReadMore>
            </span>
          </div>
        </div>
        <div className="blog-entry">
          {/* <img className="blog-img" src={""} alt="" /> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Jyoti Ranjan Mishra ||{" "}
                <a href="mailto:mishra.jyotiranjan.1999@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag">CAPEGEMINI</div>
            <span className="content-text">
              <ReadMore>
                Hello everyone this is Jyoti Ranjan Mishra. We are really
                grateful that CHESS is providing us the platform to guide our
                juniors. I was selected in Capgemini through campus placement.
                There were two rounds: Online Test and Personal Interview.
                Online test has aptitude section, essay writing section and
                technical section which includes data structures &amp;
                algorithms and pseudocodes. For aptitude I regularly practiced
                and revised the things in summer vacation itself from books as
                well as different online sites such as IndiaBix, PrepInsta etc.
                It&#39;s advisable to focus on verbal aptitude skill,
                probability, permutation-combination etc. Essay writing topic
                was easy with 160-180 word limit. Avoid spelling and grammatical
                errors and use backspace as minimum as possible. Technical round
                comprises of mcq questions based on data structures &amp;
                algorithms and pseudocodes.DS and algo questions were mostly
                theoretical. Give special focus on time complexity questions.
                Overall difficulty is 3/5. There was no GD. The Technical PI
                lasted for 25-30 minutes. It started with basic introduction and
                all and this is a point you can put your 1st impression as a
                perfect candidate for the role. Then the rest of the questions
                will move around things you have mentioned in your CV. In my
                case, I was asked about my summer project and then questions
                from based on my technical skills (C, DS, SQL) in CV. Question
                level will depend on the interviewer and it was moderate in my
                case. However, it is advisable not to lie/ extrapolate about
                your skills. Also, if you don't know an answer, don't guess
                blindly. If you are a non CS/IT student, interviewer will focus
                a lot on the projects you worked, your interest towards learning
                and coding, your attitude to implement the knowledge for
                practical purpose. If you are in any club or societies, it will
                be an added advantage.
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Tanushree Mondal ||{" "}
                <a href="https://in.linkedin.com/in/tanushree-mondal-300bb616a">
                  <i className="fa fa-linkedin" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag">HINDUSTAN UNILEVER LIMITED</div>
            <span className="content-text">
              <ReadMore>
                Hi everyone. This is Tanushree Mondal. I am glad that ChESS gave
                me the opportunity to share my interview experience with all of
                you. I was selected in HUL through campus placement. First
                shortlisting was done on the basis of CGPA and CV. There were
                two rounds after shortlisting: Technical PI and HR. Both the
                rounds were done on Skype. For PI round I would suggest to go
                through all departmental subjects thoroughly. On an average they
                asked 5-7 questions. Level of difficulty is 4/5. Mostly they ask
                questions from your training/intern and from your favorite
                subjects. In HR round they asked me why I took chemical
                engineering, what are my future plans, about my family, whether
                I am okay with remote location or not and what is supply chain.
                As a final tip I would say that answer all questions with
                confidence and try to explain in the simplest manner with
                technical terms when asked., Prepare your favorite subjects
                properly. They also check whether you have been in a place for
                too long or not because their job demands all round India
                transfer.
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " /> */}
          {/* <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Kaberi Sarkar ||{" "}
                <a href="mailto:kaberisarkar.1999@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag">TCE</div>
            <span className="content-text">
              <ReadMore>
                Hi, this is Kaberi Sarkar. I really appreciate the effort of
                Chess to help us reach out to our juniors. Firstly, I got
                selected at Tata Consulting Engineers through the campus
                placement process. There were three rounds conducted by the
                company namely, pen and paper test, technical interview and HR
                interview. For the online round, I prepared basics of chemical
                core subjects like heat transfer, mass transfer, fluid mechanics
                mainly and others like CRE, Thermodynamics etc., also a little
                bit of formulas, heat exchanger design and analogies., There
                were 30 technical questions and 30 aptitude questions for the
                online round. The level of difficulty for which was 4/5. The
                technical questions I faced in PI round were to design Heat
                exchanger on paper, tricky questions about pump and valves,
                basic ideas about distillation column and other mass transfer
                phenomenon. I was asked about my internships topics and why I
                chose design field. For the technical PI round, I prepared
                basics of chemical core subjects. Some of the HR questions that
                I faced in the PI round were to give a solution to a tricky
                situation. I was asked about the company little bit,why I wanted
                to join TCE, why I prefer design field. I was asked to mention
                my strengths and weakness, how to handle difficulty and other
                obstacles in job life etc.The level of difficulty for the PI
                round was 4/5. My take away from the interview process was that
                I had to be confident about my say and attitude matters. Some
                tips to juniors to prepare for this particular companies
                interview is that no need to mug up chemical engineering
                subjects, you should have a clear basic idea about core
                chemical, go through the basic phenomena of fluid mechanics,
                heat exchanger, mass transfer specially. Be confident about what
                you are saying because they diverts your ideas to confuse you,
                always be ready to draw heat exchanger, Valves, graphs, formulas
                etc, You need to study about the company, their field,
                innovation etc. , be confident and try to maintain eye contact
                with the interviewer and if you can't remember any topic say
                that clearly instead of making stories. Good luck.
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Aritra Karmakar ||{" "}
                <a href="mailto:aritra240@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag">TREDENCE</div>
            <span className="content-text">
              <ReadMore>
                Hey everyone. This is Aritra Karmakar. It’s a great platform
                that CHESS is providing to guide the upcoming batches of
                Chemical Engineering. I was selected in Tredence from college
                placement which is a non-core IT company. The placement process
                was conducted in three rounds: Aptitude, technical and HR. I
                practiced aptitude from Indiabix and Pariksha. For coding I
                followed geekforgeeks and some youtube videos.There were
                different sections in aptitude round, guesstimate was one of
                them. Overall level of difficulty for apti round is 4/5 . There
                was no GD round. However it will be wise to be aware about
                recent happenings around the world. In the PI round they asked
                from Sql, guesstimate and puzzles. I practiced puzzles from
                geekforgeeks and had an in-depth knowledge of Sql. In the HR
                round they again asked a few technical questions but very few.
                It was just a formality. PI round was overall 4/5 . I was
                offered the offer letter there only along with some goodies.For
                clearing the initial apti round, you need to practice apti a
                lot. Questions are easy, but time will be very less. Practice
                typing on keyboard. During the online round, 30 mins will be
                given to you and you will be told to write an essay and a
                guesstimate, both of minimum 350 words. So you need to be very
                fast. Most of my friends were unable to complete the essay and
                the guesstimate part. I completed both on time. For the
                technical round, i would suggest you guys to have a thorough
                knowledge of mysql and excel. If you know python and R , it's
                great. Also study guesstimates from various youtube videos .
                Puzzles are also very important. Just go to geekforgeeks and
                search for puzzles. You just need to see the first 100 puzzles
                and you will surely get some common questions during the
                interview. And for the Hr round, I would suggest you be
                confident about what you speak that will do the job.
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                J Anisha Rao ||{" "}
                <a href="mailto:j.nisharao@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag">ADITYA BIRLA GROUP</div>
            <span className="content-text">
              <ReadMore>
                First of all I would like to thank CheSS for proving me the
                opportunity to help my juniors. I was selected in Aditya Birla
                Group from campus placement. The placement process was held in 4
                rounds: Online Test, GD, Technical Interview and HR
                Interview.Below are the sites I had followed while preparing for
                aptitude in order of difficulty: 1. Indiabix 2.A to Z exams
                3.Pariksha 4.Lofoya 5. FACEPREP For the technical part just go
                through some of the reference books for respective subjects. In
                120 minutes we have to solve 40 aptitude questions and 60
                technical questions. Overall level of difficulty is 3/5. In the
                GD round a Case study was given where we had to analyze among
                five unique startups which was the most feasible and profitable
                one. Be vigilant about current topics and practice how to
                summarize your points. In the PI round they asked mainly from
                the industrial training I had undergone, heat exchangers,
                cooling towers and basic questions from fluid mechanics. In the
                HR round they asked questions from my CV and justification of
                what I have mentioned in it. Difficulty of the HR round was
                3/5.Remember some of the key points: 1. Never miss proposing a
                tagline or a catchy phrase at the end in GD. 2. Technical
                questions were completely based on the practical application of
                what you have learnt in 4 years. 3. HR round is how well you can
                portray yourself as the right person for them. Last but not the
                least I would like to add few more points: 1. Be very competent
                in the Online test. Work on your speed in doing minor
                calculations. 2. Improve your vocabulary 3. Try to initiate the
                talk in GD and listen patiently to what others are saying. 4. If
                you don’t know any answer just admit it. Don’t be oversmart.
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Sonu Dixit ||{" "}
                <a href="mailto:sonu.dixit.505@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag">LINDE</div>
            <span className="content-text">
              <ReadMore>
                Hi, this is Sonu Dixit. Thank you ChESS, for providing this
                platform. I got selected at Linde through the campus placement
                process. There were two rounds conducted by the company namely,
                1-written test 2-Interview. 1-For aptitude I took preparation
                from a youtube channel name genique education. 2-For technical
                part ,as I was preparing for GATE so everything came under it..
                Around 70 to 80 questions in 1 hour were asked in the online
                round, the level of difficulty being 3/5. The technical
                questions I faced in PI round were mostly practical based. I did
                not take much preparation for the technical PI round as I was
                preparing for GATE. The HR questions I faced during HR interview
                were mostly general,as other companies like : · Why linde ? ·
                Why not higher studies? · Where do you want to see yourself in
                next 5 years? The level of difficulty for which was 4/5.My
                takeaway from the interview process was that it was a good
                experience. Some tips to juniors for preparation are: · There is
                no any specific thing you need to do for this particular
                company. · Just work hard on your technical part (Heat transfer,
                fluid mechanics, mass transfer ). ALL THE BEST!
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Supratim Dey ||{" "}
                <a href="mailto:tubaione98@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag">RELIANCE INDUSTRIES LIMITED</div>
            <span className="content-text">
              <ReadMore>
                Hi, everyone. I appreciate the initiative taken by ChESS. I got
                selected in RIL through campus placement process. The different
                rounds conducted by the company were · Online aptitude +
                technical 1st round · Face to face interview 2nd round · HR
                interview final round. For the online round, focus more on
                aptitude as it carries higher weightage. Keep time limit in mind
                and attempt maximum questions with higher accuracy. The number
                of questions asked in the online round were 30 aptitude and 30
                technical, level of difficulty for which was 4/5. The type of
                technical questions I faced in PI round were: · Moderate. ·
                Subject related. · Current semester related. · Training related.
                · Basic practical application. The preparation I took for the
                technical PI round was that I cleared the basic level concept of
                every topic and the basic idea about all main equipments. Some
                HR questions I faced in the PI round were regarding: · Family
                background. · Long term goals. · Strength and weakness. ·
                Expectations from RIL. The level of difficulty for the questions
                faced in the PI rounds was 4/5. My takeaways from the interview
                process were: · Keep calm. · Never blabber if you don&#39;t know
                the answer. · Be confident, not arrogant. Some tips to juniors
                to prepare for this particular company&#39;s interview are: ·
                Basics should be clear. · Heat, mass and fluid are the main
                topics you need to focus. · Study about your training or
                internship in detail. All the very best for your future!
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Bidipta Ghosh ||{" "}
                <a href="mailto:ghoshbidipta660@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag">RELIANCE INDUSTRIES LIMITED</div>
            <span className="content-text">
              <ReadMore>
                Hi, this is Bidipta. I got selected in RIL through the campus
                placement procedure. Thank you, ChESS for giving me an
                opportunity to share my experience. The different rounds
                conducted by the company were: · Online(Aptitude + Technical) ·
                Interview (Technical + HR) I did not take any such preparation
                for the online aptitude round.Approximately, 50 questions were
                asked in the online round, the level of difficulty for which was
                ⅗. The technical questions I faced in PI round were asked from:
                · transport phenomena (fluid mechanics, especially pumps and
                valves) · control and instrumentation(close loop control system)
                · project work(recent and summer intern) · some questions from
                elective subject. For the technical PI round, I made sure that
                every line I have written in my CV is crystal clear to me and I
                can answer each of them and I went through the important chem
                engg subjects which were taught in previous semesters.The HR
                questions I faced in the PI round were: 1. Tell me about
                yourself 2. Extracurricular activities 3. Why should we select
                you over others? 4. Weakness 5. What will you do if your
                subordinates don't abide by your instructions? The level of
                difficulty for the interview process was ⅘. My takeaway from the
                interview process was that the questions (both online and
                technical PI) were the very basics of chemical engineering and
                you can easily answer them if you remember the things which were
                taught in the previous semesters. Try to be a bit smart while
                answering the HR questions but don't lie to them as they are
                much experienced than you. Some tips to my juniors to prepare
                for this particular companies interview will be: 1.Questions are
                asked in such a way that if you have the basic knowledge
                regarding the subject, you can easily answer them. 2. If you
                don't know the exact answer, try to approach the question in a
                logical manner. 3. Don't write anything in your CV which you are
                not well aware of. Good luck !!
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Ananya Ghosh ||{" "}
                <a href="mailto:anu17ananya@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag">LINDE</div>
            <span className="content-text">
              <ReadMore>
                Hi, this is Ananya. Thank you for asking me to share my
                experience. I got selected in Linde by the campus recruitment
                process. There were three different rounds conducted by the
                company namely, Pen and Paper Test (includes technical, aptitude
                and english), PI (technical and HR). For the pen and paper test,
                I checked in glassdoor.com that what kind of questions they
                generally ask, and then I prepare accordingly. There were around
                50 questions for the pen and paper round, the level of
                difficulty for which was 4/5. Generally Linde takes GD but in
                our time due to less number of students who qualified the pen
                and paper test, GD didn&#39;t happen. Linde's GD topics are
                mostly on trending and common issues. Technical Questions in the
                PI round, started from my favourite subject then interviewer
                tried to link it with Thermodynamics and then some basic
                questions from Physics and Chemistry. Mostly, basics questions
                were asked in the PI round. For the technical round I mostly
                focused on the unit operations and different types of equipment,
                their working principles and most importantly thermodynamic
                processes and cycles. In the HR round, normal HR questions like
                Tell about yourself (background + education + hobbies), passion
                in life, aspirations, where you see yourself after 5 years,
                which domain you would like to work in Linde (process/sales),
                any location problem, interested in doing MBA or not and why
                (never say NO, try to give diplomatic answer) etc. were asked.
                The level of difficulty for the PI round was 4/5. My take away
                from the interview process was: 1. Be confident and maintain eye
                contact with a gentle smile 2. Give positive responses to every
                question, don't say direct NO to any question. Try to be little
                diplomatic. 3. Focus on your forte. Some tips to juniors to
                prepare for this particular company&#39;s interview are: 1.
                Focus on the pure basics of chemical engineering. 2. Prepare
                Thermodynamics thoroughly 3. Study about every equipment
                (including compressor), it&#39;s working principles. All the
                best.
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Polaki Sri Kavya ||{" "}
                <a href="mailto:srikavyapolaki@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag">PRADAN</div>
            <span className="content-text">
              <ReadMore>
                Hi, everyone. This is Polaki Sri Kavya, I got selected at PRADAN
                through the campus placement procedure. There were three
                different rounds conducted by the company.For the online round
                I, basically prepared for the Non verbal Reasoning. 100
                questions were asked in the online round, the level of
                difficulty for which was 3/5. In the GD round, the topic given
                to us was illegal affair. In the PI round, I was asked if I was
                comfortable with any locality. The level of difficulty of the PI
                round was 3/5. Some tips to juniors to prepare for this
                particular companies interview would be that you should be fast
                enough in reasoning. All the best.
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Monalisa Gorain ||{" "}
                <a href="mailto:monalisa.gorain@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag">RELIANCE INDUSTRIES LIMITED</div>
            <span className="content-text">
              <ReadMore>
                Hi, this is Monalisa Gorain. I got selected in Reliance
                Industries Limited by the campus placement procedure. I
                practiced aptitude questions from pariksha and brushed up the
                important concepts and formula of fluid mechanics, mass
                transfer, heat transfer, cre and process control before the
                test. Many of the previous year gate questions are repeated, so
                if you are a gate aspirant and preparing for it, it will
                definitely provide you an upper hand. Time will be short, so
                make sure you don't waste a lot of time on a problem. There were
                30 aptitude questions and 50 technical questions in the online
                round, the level of difficulty for which was 3/5. Reliance came
                for recruitment for 2 different positions for our batch- for
                RPMG and for Operations. So the very first question t. 3 rounds
                were conducted by the company. First one was the online
                (technical+aptitude) round, second was the technical interview
                round and finally the HR round. I think the online round was the
                most crucial round. Around 45 students sat for the online test
                and only 10 were shortlisted hat I was asked in my PI round was
                why I wanted to go for operations and not RPMG. I was cross
                questioned on answering that. Then they asked me some basic
                questions of fluid mechanics related to bernoulli’s theorem and
                pumps (cavitation, types and utilities). They were not exactly
                direct questions rather application based so make sure you have
                crystal clear concepts of your core subjects. I had done my 3rd
                year summer training at IOCL Haldia, so next part of the
                interview was completely based on that. I was asked questions
                about various units of the refinery (functions, products, inlet
                stream source, outlet stream destination). Most of the questions
                were based on sulphur removal from crude petroleum. Then I was
                asked, if electric cars completely take over the market, what
                would happen to reliance. And then finally the technical
                interview ended with some HR questions. For the technical PI
                round, I made sure to have my basics clear of my core
                subjects(heat transfer, mass transfers, cre, fluid mechanics and
                process control). I asked my seniors about the interview
                process, they told me that small problems could be asked to
                solve, so I went through the important formulas. I read about my
                projects and trainings before interview. The first question in
                the HR round was the same as the technical interview round i.e
                why I went for operations and not RPMG. Second, was why I wanted
                to join reliance. Then they asked me to name five companies from
                the Fortune 500 list. Then they asked about my takeaways from
                IOCL Haldia. Then some questions about club and stuff. Then they
                finally asked me, what if they paid me 4 lakhs and gave a chance
                to work in their refinery. The level of difficulty in the PI
                round was also 3/5. I think with every interview I improved. I
                learned to represent myself with confidence. I retrospect on
                what went wrong and work towards improving that. Besides I got
                to know alot about Reliance Industries and the various perks of
                working at Reliance. Some tips to juniors to prepare for this
                particular company&#39;s interview are that try to do training
                in some refinery or petrochemical industry. That&#39;s the job
                you will have to do at Reliance being a chemical engineer, so
                prior experience will obviously provide you advantage both in
                the interview and your job. Besides you will get exposed to
                almost every unit operation you have studied. All the best.
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Aradhna Lama Yolmo ||{" "}
                <a href="mailto:aradhna.542@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag">Helium Consulting</div>
            <span className="content-text">
              <ReadMore>
                Hi , this is Aradhna and I got selected at Helium Consulting
                through campus placement. The different rounds conducted by the
                company were: 1) HR round 2) TECHNICAL + HR round 3) Technical
                round 4) Problem solving and personal interaction with the
                Director For the online round, I prepared some Guesstimate
                questions from Google and YouTube, technical questions and
                conceptual questions from books and notes. 6-7 questions were
                asked in the online round, the level of difficulty for which was
                3/5. The technical questions I faced in the PI round, were
                mostly related to the Project and vocational training. For the
                technical PI round, I thoroughly read my project and the units
                covered in my vocational training. The HR questions I faced in
                the PI round were based on: · Strengths and weaknesses · How
                hard working are you? · Family background · Future plans ·
                Further studies The level of difficulty for which was 4/5. My
                takeaway from the interview process was that drive the interview
                process according to you and not according to them. Some tips to
                juniors to prepare for this particular company&#39;s interview
                are do not take out a topic which is bizzare to you. Instead,
                put forward the topics you know. And be confident.
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Shahbal Akhter Ansari ||{" "}
                <a href="mailto:netshahbal@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag"> ADITYA BIRLA GROUP</div>
            <span className="content-text">
              <ReadMore>
                Hello everyone this is Shahbal from 2020 batch. I was selected
                in Aditya Birla Group through campus placement process. Overall
                there were 3 rounds namely an Online test, GD(case study) and
                PI. For aptitude part I practised from IndiaBix website and
                watched CareerRide Youtube channel for shortcuts and tricks. The
                online test has following sections: LR, Quantitative Aptitude,
                English, Technical Questions and Personality Testing. Overall
                the difficulty was 3/5. In the GD round we have to solve one
                case study. In the technical questions they asked from cooling
                tower, unit conversion, LMTD, types of pump, pump efficiency,
                types of evaporator, steam economy, pump characteristics curve
                etc. For the technical portion I would recommend standard
                textbooks and youtube channels like chemicalpedia. In the HR
                round they asked me about my weakness(es). Level of difficulty
                of PI was 3/5. Interviewer will try to persuade you to change
                your answer so be confident if you’re right. Distillation
                columns, pumps, heat exchangers, evaporators are important
                topics, so study the in depth concept thoroughly.
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Naveen Kumar ||{" "}
                <a href="mailto:naveen.kr98@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag"> RELIANCE INDUSTRIES LIMITED</div>
            <span className="content-text">
              <ReadMore>
                Hello everyone, this is Naveen Kumar. I was selected in Reliance
                Industries Limited through campus placement process. Overall
                there were 3 rounds : Online test, Technical PI and HR
                interview. For the online test I practiced both technical and
                aptitude part from IndiaBix. I followed Genique Education
                youtube channel and my personal chemical notes. In the online
                test we have to solve 30 apti questions in 30 min and 50
                technical questions in 30 min. The difficulty level was 4/5.
                There was no GD round. In the technical round they asked from my
                summer training which I did at IOCL Barauni and from topics such
                as fluid, mass transfer and heat transfer. I had revised all the
                process flow diagrams of different units I had visited during my
                training. I had prepared my own notes of heat and mass transfer.
                For Fluid mechanics and CRE I revised the whole notes given by
                PPG Sir. In the HR round they asked about why I want to join
                reliance, what are my strengths and weaknesses, my long term
                goal and where do I see myself after 5 years. Level of
                difficulty of HR and PI was 3/5. Your basics should be clear and
                be humble in your tone. As a tip I would suggest that you should
                be careful while making your CV. Don’t write anything that you
                don’t know.
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Neha ||{" "}
                <a href="mailto:nehasweet3333@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag"> Aditya Birla Group</div>
            <span className="content-text">
              <ReadMore>
                Hello I’m Neha. The selection procedure of Aditya Birla in my
                case consisted of rounds - Physcometric test, aptitude test,
                technical test, 2 technical plus HR rounds. For the online round
                I took preparation from India bix website and gate aptitude
                questions.60 aptitude question for 1 hour and 30 technical
                questions for half an hour were asked in the first round. Level
                of difficulty of Online round : 3. We had GT round.No special
                preparation for GD/GT but among freinds we have discussed on
                different topics and for some days we were simply talking in
                English language only. The Technical PI round questions I faced
                was based on favorite subject that you have, they are asking
                from it and also asked technical question from different
                subjects apart from favorite one. They also asked questions from
                your second year and third year projects and training that you
                did. My preparation for technical round was : Studied the
                favorite subjects, second year projects and third year training
                reports very well and I advised you all my junis to do the same
                and for gate preparators it&#39;s become easy to do the
                preparation. HR Questions I faced are : Strength and weakness,
                hobby and tell me something about yourself, given the condition
                and asked how to react in that condition. My takeaway from the
                interview is : Focus on basics of everything... The subject you
                studied and your fav subject .Be confident and in each process
                of company&#39;s placement show moral values and present your
                moral views where you get the chance. Tips to juniors - Be
                yourself, study one subject completely, prepare well with your
                second year and third year training and project, always present
                yourself with having moral values and views.
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Disha Dhar ||{" "}
                <a href="mailto:disha.dhar98@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag">
              {" "}
              Novartis Healthcare Private Limited
            </div>
            <span className="content-text">
              <ReadMore>
                Hi Disha here. Selection Rounds were : Online aptitude round,GD
                round,Case study round,Technical PI,HR PI. For preparation of
                online round It requires knowledge of basic Maths and English
                from school level. There was a GD round and my topic was “Is
                India ready for digital economy”. Nothing much as a preparation
                for GD, just need to be aware of current issues going around
                oneself. In technical PI round , Mostly questions about my,
                internship and some from my projects and academics.My
                preparation for the Technical round was that I cleared all my
                doubts about my projects and internships. In HR round, I faced
                Mostly questions about why did I want to join the company, why
                that job role,why that location and job sector. Takeway from the
                interview - “If I don't know about anything I must be confident
                enough to say a &#39;no&#39; rather than pretend.”. Tips to my
                juniors - They want mostly active learners because none of us
                freshers can know much about medicines or analytics.
              </ReadMore>
            </span>
          </div>
        </div>
        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Devyansh Singh ||{" "}
                <a href="mailto:singhdev9255@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag"> PI Industries</div>
            <span className="content-text">
              <ReadMore>
                Selection procedures in my case were : Offline pen and paper
                test, GD, Technical INterview, HR round. For the first round, I
                took no special preparation, just had basic knowledge. There
                were 20 questions from technical pen and paper round. My GD
                topic was - “How you can save the Enviroment”. No special
                preparation I took for GD but Be aware with the current topics
                and have a good communication skills. In my technical interview
                , they asked mainly from Mass Transfer. HR Round Questions :
                1.Tell me about yourself 2.your family background 3.strength and
                weakness 4.Have you solve any complex problem? 5.Have you face
                any problem in academics.How will you solve it? 6.Any situation
                in which you feel are guiding people?How they have reacted?Have
                you convinced them your ideas? 7.why do you have chosen chemical
                engineering? 8.Do you have any plans for MBA? 9.Do you want to
                do Higher studies? 10.In your CV you have listed ,you are
                interested in coding? why you want to join a plant ?
                11.Disscussion on CV 12.Hobbies? 13.Any question do you want to
                ask ? Tips to juniors : prepare the basic principles of Chemical
                Engineering,Aptitude and Be confident. Presence of Mind and self
                awareness.These two will lend you a Job.
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Sayan Goswami ||{" "}
                <a href="mailto:sayangoswami1972@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag"> PI Industries</div>
            <span className="content-text">
              <ReadMore>
                Selection rounds were : Technical, GD, PI. First round was It
                was offline and 30 questions were asked. No preparation for
                first round. My GD topic was “Environmental concerns”. No
                preparation for GD. Technical questions I faced are : Numerical
                to calculate economy and steam consumption and heat load in
                evaporator, Write the analogies (Reynold, Prandtl, Coulborn),
                What happens to head and flow rate if pumps are in series and
                parallel?, Define NPSH,cavitation, Type of pumps, Questions
                related to training. HR Questions I faced : Why not Mtech?, Can
                u relocate? So you are from east and would ge going to west so
                can You do job? Will Your parents allow you?, What makes you
                angry?, where do you like to see yourself after 5 years?, Define
                management. My takeaway from interview : Interviews became
                monotonous for me as I was getting same type of HR questions
                till being placed. Tips to juniors : Do a academic project.
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                TT Sriram ||{" "}
                <a href="https://in.linkedin.com/in/sri-ram-40a837190">
                  <i className="fa fa-linkedin" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag"> RELIANCE INDUSTRIES LIMITED</div>
            <span className="content-text">
              <ReadMore>
                Aptitude round preparation can be done from the websites like
                IndiaBix. There were 30-aptitude,50-technical mcq. There is no
                GD round in RIL But still we can prepare GD by discussing about
                the current affairs between friends and also practising it
                individually. Fortunately or unfortunately I got RPMG panel of
                RIL. They ask numerous technical questions focusing mainly, on
                distillation from mass transfer and Pumps in fluid mechanics and
                heat exchangers in heat transfer. They mainly focus on the
                different extreme conditions of the topic. For example: They ask
                questions on blowdown and floding conditions on distillation,
                NPSH calculations of pumps, Different types of trays and their
                advantages and disadvantages in distillation column etc. They
                also ask questions to test our presence of mind and our
                applicational abilities. For example There is a pool of water
                and we need to evaporate it what are the methods we suggest ( we
                can consider any assumption we want). These are few questions
                they asked me. My Preparation for Technical round : Follow the
                className notes even if it is basic it will be easy to answer
                questions spontaneously. Deep study on the topics
                -Distillation,Heat exchangers, pumps is necessary. I done it
                from online NPTEl lectures and followed DS sir notes( a
                professor in Calcutta university, he offers gate coaching). HR
                round is just for name sake. They asked basic questions like
                tell me about yourself etc. but prepare for this question
                perfectly. A form will be provided by RIL which should be filled
                before PI. Fill the CV and form in such a way so that they can’t
                point out any point In your form. Don’t write any false
                statements in form. Takeaway from interview : It’s not too
                difficult or not too easy but we have to be patient and doesn’t
                loose our control of mind and hope in interview. Tips to juniors
                : Above all can be followed only when you clear apti round. So
                practise aptitude everyday it has more weightage than technical
                round. So concentrate on it. Be patient and calm during
                interview and use paper and pen more in the interview it helps
                more.(paper and pen will be provided in interview ).
              </ReadMore>
            </span>
          </div>
        </div>

        <div className="blog-entry">
          {/* <img className="blog-img" src={" "} alt=" " />
        <div className="content-date">
          <div className="date">2020</div>
        </div> */}
          <div className="blog-content">
            <div className="content-title">
              <h1>
                Ritika Das ||{" "}
                <a href="mailto:dasritika98@gmail.com">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </a>
              </h1>
            </div>
            <div className="content-tag"> Saint-Gobain India Pvt Ltd</div>
            <span className="content-text">
              <ReadMore>
                Selection rounds were : Technical, GD, PI. First round was It
                was offline and 30 questions were asked. No preparation for
                first round. My GD topic was “Environmental concerns”. No
                preparation for GD. Technical questions I faced are : Numerical
                to calculate economy and steam consumption and heat load in
                evaporator, Write the analogies (Reynold, Prandtl, Coulborn),
                What happens to head and flow rate if pumps are in series and
                parallel?, Define NPSH,cavitation, Type of pumps, Questions
                related to training. HR Questions I faced : Why not Mtech?, Can
                u relocate? So you are from east and would ge going to west so
                can You do job? Will Your parents allow you?, What makes you
                angry?, where do you like to see yourself after 5 years?, Define
                management. My takeaway from interview : Interviews became
                monotonous for me as I was getting same type of HR questions
                till being placed. Tips to juniors : Do a academic project.
              </ReadMore>
            </span>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Blog;
